import { PlatformLocation } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import * as moment from 'moment';
import { first } from 'rxjs/operators';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { FleetModel } from '../../titleregistration/models/fleet.model';
import { FleetService } from '../../titleregistration/services/fleet.service';
import { FleetStatusType } from '../../vehicle/models/enums/fleet-status-type.enum';
import { FleetType, IFleetType } from '../../vehicle/models/enums/fleet-type.enum';
import { CustomerAccountService } from '../account/service/customer-account.service';
import { CustomerAccountDetail } from '../models/customer-account-detail.model';
import { CustomerType } from '../models/enums/customer-type.enum';
import { CustomerModalBaseComponent } from '../shared/customer-modal-base.component';

export class CreateFleetContext {
    public customerAccountNumberId: number;
    public expirationDate: string;
    public fleetTypeId: number;

    constructor(public customerNumberId: number, public customerTypeId: number, public fleets: FleetModel[]) {}
}

@Component({
    templateUrl: './create-fleet-modal.html'
})
export class CreateFleetModalComponent extends CustomerModalBaseComponent {
    customerNumberId: number;
    fleetCreationForm: UntypedFormGroup;
    generatedEndDates: string[] = new Array();
    fleetTypes: IFleetType[] = new FleetType().GetActive();
    customerAccountNumbers: CustomerAccountDetail[];
    public fleetStatusType = new FleetStatusType();
    private customerTypes = new CustomerType();

    constructor(
        public location: PlatformLocation,
        public fb: UntypedFormBuilder,
        public dialogRef: MatDialogRef<CreateFleetModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: CreateFleetContext,
        public modalService: MvdModalService,
        private customerAccountService: CustomerAccountService,
        private fleetService: FleetService
    ) {
        super(modalService);

        this.customerNumberId = this.data.customerNumberId;

        const now = moment();
        for (let i = 0; i < 15; i++) {
            now.add('month', 1).endOf('month');

            if (!this.data.fleets || !this.data.fleets.filter(x => x.fleetStatusTypeId != this.fleetStatusType.Cancel.id && moment(x.expirationDate).month() == now.month()).length) {
                this.generatedEndDates.push(now.format('MM/DD/YYYY'));
            }
        }

        location.onPopState(() => {
            this.dialogRef.close();
        });

        this.fleetTypes = [new FleetType().PermanentFleetRegistration];
    }

    async ngOnInit() {
        this.fleetCreationForm = this.fb.group({
            'expirationDate': ['', Validators.required],
            'fleetType': ['', Validators.required],
            'customerAccountNumber': ['', Validators.required]
        });

        const customerAccountDetailsWithValidation = await this.customerAccountService.getCustomerAccounts(this.customerNumberId).pipe(first()).toPromise();
        this.customerAccountNumbers = customerAccountDetailsWithValidation && customerAccountDetailsWithValidation.result;
    }

    public cancel() {
        this.dialogRef.close();
    }

    public async save() {
        try {
            var model = new FleetModel();
            model.customerNumberId = this.data.customerNumberId;
            model.customerAccountNumberId = +this.fleetCreationForm.get('customerAccountNumber').value;
            model.expirationDate = moment(this.fleetCreationForm.get('expirationDate').value).toDate();
            model.fleetTypeId = +this.fleetCreationForm.get('fleetType').value;
            model.fleetStatusTypeId = this.fleetStatusType.Active.id;

            await this.fleetService.saveFleet(model).pipe(first()).toPromise();

            this.dialogRef.close(model);
        } catch (err) {
            this.handleValidationResult(err);
        }
    }
}
